export default __webpack_public_path__ + "static/media/warning--slippery-bicycles--g1.44fe2519.png";